module.exports = __webpack_public_path__ + "img/Icon material-dashboard.c144ea10.svg";